let data = {
  province: [
    {
      Bin: 11,
      Name: "北京市"
    },
    {
      Bin: 12,
      Name: "天津市"
    },
    {
      Bin: 13,
      Name: "河北省"
    },
    {
      Bin: 14,
      Name: "山西省"
    },
    {
      Bin: 15,
      Name: "内蒙古"
    },
    {
      Bin: 21,
      Name: "辽宁省"
    },
    {
      Bin: 22,
      Name: "吉林省"
    },
    {
      Bin: 23,
      Name: "黑龙江省"
    },
    {
      Bin: 31,
      Name: "上海市"
    },
    {
      Bin: 32,
      Name: "江苏省"
    },
    {
      Bin: 33,
      Name: "浙江省"
    },
    {
      Bin: 34,
      Name: "安徽省"
    },
    {
      Bin: 35,
      Name: "福建省"
    },
    {
      Bin: 36,
      Name: "江西省"
    },
    {
      Bin: 37,
      Name: "山东省"
    },
    {
      Bin: 41,
      Name: "河南省"
    },
    {
      Bin: 42,
      Name: "湖北省"
    },
    {
      Bin: 43,
      Name: "湖南省"
    },
    {
      Bin: 44,
      Name: "广东省"
    },
    {
      Bin: 45,
      Name: "广西省"
    },
    {
      Bin: 46,
      Name: "海南省"
    },
    {
      Bin: 50,
      Name: "重庆市"
    },
    {
      Bin: 51,
      Name: "四川省"
    },
    {
      Bin: 52,
      Name: "贵州省"
    },
    {
      Bin: 53,
      Name: "云南省"
    },
    {
      Bin: 54,
      Name: "西藏"
    },
    {
      Bin: 61,
      Name: "陕西省"
    },
    {
      Bin: 62,
      Name: "甘肃省"
    },
    {
      Bin: 63,
      Name: "青海省"
    },
    {
      Bin: 64,
      Name: "宁夏"
    },
    {
      Bin: 65,
      Name: "新疆"
    },
    {
      Bin: 71,
      Name: "台湾省"
    },
    {
      Bin: 81,
      Name: "香港"
    },
    {
      Bin: 82,
      Name: "澳门"
    }
  ],
  city: [
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 11,
      ProvinceName: "北京市"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 12,
      ProvinceName: "天津市"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130100,
      Name: "石家庄市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130200,
      Name: "唐山市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130300,
      Name: "秦皇岛市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130400,
      Name: "邯郸市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130500,
      Name: "邢台市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130600,
      Name: "保定市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130700,
      Name: "张家口市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130800,
      Name: "承德市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 130900,
      Name: "沧州市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 131000,
      Name: "廊坊市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 131100,
      Name: "衡水市",
      ProvinceBin: 13,
      ProvinceName: "河北省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140100,
      Name: "太原市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140200,
      Name: "大同市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140300,
      Name: "阳泉市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140400,
      Name: "长治市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140500,
      Name: "晋城市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140600,
      Name: "朔州市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140700,
      Name: "晋中市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140800,
      Name: "运城市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 140900,
      Name: "忻州市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 141000,
      Name: "临汾市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 141100,
      Name: "吕梁市",
      ProvinceBin: 14,
      ProvinceName: "山西省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150100,
      Name: "呼和浩特市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150200,
      Name: "包头市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150300,
      Name: "乌海市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150400,
      Name: "赤峰市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150500,
      Name: "通辽市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150600,
      Name: "鄂尔多斯市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150700,
      Name: "呼伦贝尔市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150800,
      Name: "巴彦淖尔市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 150900,
      Name: "乌兰察布市",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 152200,
      Name: "兴安盟",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 152500,
      Name: "锡林郭勒盟",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 152900,
      Name: "阿拉善盟",
      ProvinceBin: 15,
      ProvinceName: "内蒙古"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210100,
      Name: "沈阳市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210200,
      Name: "大连市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210300,
      Name: "鞍山市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210400,
      Name: "抚顺市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210500,
      Name: "本溪市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210600,
      Name: "丹东市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210700,
      Name: "锦州市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210800,
      Name: "营口市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 210900,
      Name: "阜新市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 211000,
      Name: "辽阳市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 211100,
      Name: "盘锦市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 211200,
      Name: "铁岭市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 211300,
      Name: "朝阳市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 211400,
      Name: "葫芦岛市",
      ProvinceBin: 21,
      ProvinceName: "辽宁省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220100,
      Name: "长春市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220200,
      Name: "吉林市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220300,
      Name: "四平市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220400,
      Name: "辽源市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220500,
      Name: "通化市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220600,
      Name: "白山市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220700,
      Name: "松原市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 220800,
      Name: "白城市",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 222400,
      Name: "延边朝鲜族自治州",
      ProvinceBin: 22,
      ProvinceName: "吉林省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230100,
      Name: "哈尔滨市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230200,
      Name: "齐齐哈尔市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230300,
      Name: "鸡西市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230400,
      Name: "鹤岗市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230500,
      Name: "双鸭山市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230600,
      Name: "大庆市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230700,
      Name: "伊春市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230800,
      Name: "佳木斯市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 230900,
      Name: "七台河市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 231000,
      Name: "牡丹江市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 231100,
      Name: "黑河市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 231200,
      Name: "绥化市",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 232700,
      Name: "大兴安岭地区",
      ProvinceBin: 23,
      ProvinceName: "黑龙江省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 31,
      ProvinceName: "上海市"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320100,
      Name: "南京市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320200,
      Name: "无锡市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320300,
      Name: "徐州市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320400,
      Name: "常州市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320500,
      Name: "苏州市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320600,
      Name: "南通市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320700,
      Name: "连云港市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320800,
      Name: "淮安市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 320900,
      Name: "盐城市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 321000,
      Name: "扬州市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 321100,
      Name: "镇江市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 321200,
      Name: "泰州市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 321300,
      Name: "宿迁市",
      ProvinceBin: 32,
      ProvinceName: "江苏省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330100,
      Name: "杭州市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330200,
      Name: "宁波市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330300,
      Name: "温州市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330400,
      Name: "嘉兴市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330500,
      Name: "湖州市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330600,
      Name: "绍兴市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330700,
      Name: "金华市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330800,
      Name: "衢州市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 330900,
      Name: "舟山市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 331000,
      Name: "台州市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 331100,
      Name: "丽水市",
      ProvinceBin: 33,
      ProvinceName: "浙江省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340100,
      Name: "合肥市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340200,
      Name: "芜湖市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340300,
      Name: "蚌埠市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340400,
      Name: "淮南市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340500,
      Name: "马鞍山市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340600,
      Name: "淮北市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340700,
      Name: "铜陵市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 340800,
      Name: "安庆市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341000,
      Name: "黄山市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341100,
      Name: "滁州市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341200,
      Name: "阜阳市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341300,
      Name: "宿州市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341400,
      Name: "巢湖市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341500,
      Name: "六安市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341600,
      Name: "亳州市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341700,
      Name: "池州市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 341800,
      Name: "宣城市",
      ProvinceBin: 34,
      ProvinceName: "安徽省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350100,
      Name: "福州市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350200,
      Name: "厦门市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350300,
      Name: "莆田市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350400,
      Name: "三明市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350500,
      Name: "泉州市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350600,
      Name: "漳州市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350700,
      Name: "南平市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350800,
      Name: "龙岩市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 350900,
      Name: "宁德市",
      ProvinceBin: 35,
      ProvinceName: "福建省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360100,
      Name: "南昌市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360200,
      Name: "景德镇市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360300,
      Name: "萍乡市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360400,
      Name: "九江市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360500,
      Name: "新余市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360600,
      Name: "鹰潭市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360700,
      Name: "赣州市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360800,
      Name: "吉安市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 360900,
      Name: "宜春市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 361000,
      Name: "抚州市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 361100,
      Name: "上饶市",
      ProvinceBin: 36,
      ProvinceName: "江西省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370100,
      Name: "济南市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370200,
      Name: "青岛市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370300,
      Name: "淄博市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370400,
      Name: "枣庄市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370500,
      Name: "东营市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370600,
      Name: "烟台市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370700,
      Name: "潍坊市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370800,
      Name: "济宁市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 370900,
      Name: "泰安市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371000,
      Name: "威海市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371100,
      Name: "日照市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371200,
      Name: "莱芜市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371300,
      Name: "临沂市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371400,
      Name: "德州市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371500,
      Name: "聊城市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371600,
      Name: "滨州市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 371700,
      Name: "菏泽市",
      ProvinceBin: 37,
      ProvinceName: "山东省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410100,
      Name: "郑州市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410200,
      Name: "开封市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410300,
      Name: "洛阳市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410400,
      Name: "平顶山市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410500,
      Name: "安阳市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410600,
      Name: "鹤壁市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410700,
      Name: "新乡市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410800,
      Name: "焦作市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 410900,
      Name: "濮阳市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411000,
      Name: "许昌市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411100,
      Name: "漯河市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411200,
      Name: "三门峡市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411300,
      Name: "南阳市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411400,
      Name: "商丘市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411500,
      Name: "信阳市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411600,
      Name: "周口市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 411700,
      Name: "驻马店市",
      ProvinceBin: 41,
      ProvinceName: "河南省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420100,
      Name: "武汉市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420200,
      Name: "黄石市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420300,
      Name: "十堰市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420500,
      Name: "宜昌市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420600,
      Name: "襄樊市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420700,
      Name: "鄂州市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420800,
      Name: "荆门市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 420900,
      Name: "孝感市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 421000,
      Name: "荆州市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 421100,
      Name: "黄冈市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 421200,
      Name: "咸宁市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 421300,
      Name: "随州市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 422800,
      Name: "恩施土家族苗族自治州",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 429021,
      Name: "神农架林区",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 429006,
      Name: "天门市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 429004,
      Name: "仙桃市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 429005,
      Name: "潜江市",
      ProvinceBin: 42,
      ProvinceName: "湖北省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430100,
      Name: "长沙市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430200,
      Name: "株洲市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430300,
      Name: "湘潭市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430400,
      Name: "衡阳市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430500,
      Name: "邵阳市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430600,
      Name: "岳阳市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430700,
      Name: "常德市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430800,
      Name: "张家界市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 430900,
      Name: "益阳市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 431000,
      Name: "郴州市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 431100,
      Name: "永州市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 431200,
      Name: "怀化市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 431300,
      Name: "娄底市",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 433100,
      Name: "湘西土家族苗族自治州",
      ProvinceBin: 43,
      ProvinceName: "湖南省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440100,
      Name: "广州市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440200,
      Name: "韶关市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440300,
      Name: "深圳市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440400,
      Name: "珠海市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440500,
      Name: "汕头市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440600,
      Name: "佛山市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440700,
      Name: "江门市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440800,
      Name: "湛江市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 440900,
      Name: "茂名市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },

    {
      Bin: 441200,
      Name: "肇庆市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441300,
      Name: "惠州市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441400,
      Name: "梅州市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441500,
      Name: "汕尾市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441600,
      Name: "河源市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441700,
      Name: "阳江市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441800,
      Name: "清远市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 441900,
      Name: "东莞市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 442000,
      Name: "中山市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 445100,
      Name: "潮州市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 445200,
      Name: "揭阳市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 445300,
      Name: "云浮市",
      ProvinceBin: 44,
      ProvinceName: "广东省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450100,
      Name: "南宁市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450200,
      Name: "柳州市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450300,
      Name: "桂林市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450400,
      Name: "梧州市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450500,
      Name: "北海市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450600,
      Name: "防城港市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450700,
      Name: "钦州市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450800,
      Name: "贵港市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 450900,
      Name: "玉林市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 451000,
      Name: "百色市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 451100,
      Name: "贺州市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 451200,
      Name: "河池市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 451300,
      Name: "来宾市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 451400,
      Name: "崇左市",
      ProvinceBin: 45,
      ProvinceName: "广西省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469003,
      Name: "儋州市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469005,
      Name: "文昌市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469033,
      Name: "乐东黎族自治县",
      ProvinceBin: 46,
      ProvinceName: "五指山市"
    },
    {
      Bin: 460200,
      Name: "三亚市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469036,
      Name: "琼中黎族苗族自治县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469007,
      Name: "东方市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 460100,
      Name: "海口市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469006,
      Name: "万宁市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469027,
      Name: "澄迈县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469030,
      Name: "白沙黎族自治县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469002,
      Name: "琼海市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469031,
      Name: "昌江黎族自治县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469028,
      Name: "临高县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469034,
      Name: "陵水黎族自治县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469026,
      Name: "屯昌县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469025,
      Name: "定安县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469035,
      Name: "保亭黎族苗族自治县",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 469001,
      Name: "五指山市",
      ProvinceBin: 46,
      ProvinceName: "海南省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 50,
      ProvinceName: "重庆市"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510100,
      Name: "成都市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510300,
      Name: "自贡市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510400,
      Name: "攀枝花市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510500,
      Name: "泸州市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510600,
      Name: "德阳市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510700,
      Name: "绵阳市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510800,
      Name: "广元市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 510900,
      Name: "遂宁市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511000,
      Name: "内江市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511100,
      Name: "乐山市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511300,
      Name: "南充市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511400,
      Name: "眉山市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511500,
      Name: "宜宾市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511600,
      Name: "广安市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511700,
      Name: "达州市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },

    {
      Bin: 511800,
      Name: "雅安市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 511900,
      Name: "巴中市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 512000,
      Name: "资阳市",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 513300,
      Name: "甘孜藏族自治州",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 513200,
      Name: "阿坝藏族羌族自治州",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 513400,
      Name: "凉山彝族自治州",
      ProvinceBin: 51,
      ProvinceName: "四川省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 520100,
      Name: "贵阳市",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 520200,
      Name: "六盘水市",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 520300,
      Name: "遵义市",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 520400,
      Name: "安顺市",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 522200,
      Name: "铜仁地区",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 522300,
      Name: "黔西南布依族苗族自治州",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 522400,
      Name: "毕节地区",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 522600,
      Name: "黔东南苗族侗族自治州",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 522700,
      Name: "黔南布依族苗族自治州",
      ProvinceBin: 52,
      ProvinceName: "贵州省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530100,
      Name: "昆明市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530300,
      Name: "曲靖市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530400,
      Name: "玉溪市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530500,
      Name: "保山市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530600,
      Name: "昭通市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530700,
      Name: "丽江市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530800,
      Name: "普洱市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 530900,
      Name: "临沧市",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 532300,
      Name: "楚雄彝族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 532500,
      Name: "红河哈尼族彝族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 532600,
      Name: "文山壮族苗族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 532800,
      Name: "西双版纳傣族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 532900,
      Name: "大理白族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 533100,
      Name: "德宏傣族景颇族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 533300,
      Name: "怒江傈僳族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },

    {
      Bin: 533400,
      Name: "迪庆藏族自治州",
      ProvinceBin: 53,
      ProvinceName: "云南省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 540100,
      Name: "拉萨市",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 542100,
      Name: "昌都地区",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 542200,
      Name: "山南地区",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 542300,
      Name: "日喀则地区",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 542400,
      Name: "那曲地区",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 542500,
      Name: "阿里地区",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 542600,
      Name: "林芝地区",
      ProvinceBin: 54,
      ProvinceName: "西藏"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610100,
      Name: "西安市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610200,
      Name: "铜川市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610300,
      Name: "宝鸡市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610400,
      Name: "咸阳市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610500,
      Name: "渭南市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610600,
      Name: "延安市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610700,
      Name: "汉中市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610800,
      Name: "榆林市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 610900,
      Name: "安康市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 611000,
      Name: "商洛市",
      ProvinceBin: 61,
      ProvinceName: "陕西省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620100,
      Name: "兰州市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620200,
      Name: "嘉峪关市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620300,
      Name: "金昌市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620400,
      Name: "白银市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620500,
      Name: "天水市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620600,
      Name: "武威市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620700,
      Name: "张掖市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620800,
      Name: "平凉市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 620900,
      Name: "酒泉市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 621000,
      Name: "庆阳市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 621100,
      Name: "定西市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 621200,
      Name: "陇南市",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 622900,
      Name: "临夏回族自治州",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 623000,
      Name: "甘南藏族自治州",
      ProvinceBin: 62,
      ProvinceName: "甘肃省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 630100,
      Name: "西宁市",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632100,
      Name: "海东地区",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632200,
      Name: "海北藏族自治州",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632300,
      Name: "黄南藏族自治州",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632500,
      Name: "海南藏族自治州",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632600,
      Name: "果洛藏族自治州",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632700,
      Name: "玉树藏族自治州",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 632800,
      Name: "海西蒙古族藏族自治州",
      ProvinceBin: 63,
      ProvinceName: "青海省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 64,
      ProvinceName: "宁夏"
    },
    {
      Bin: 640100,
      Name: "银川市",
      ProvinceBin: 64,
      ProvinceName: "宁夏"
    },
    {
      Bin: 640200,
      Name: "石嘴山市",
      ProvinceBin: 64,
      ProvinceName: "宁夏"
    },
    {
      Bin: 640300,
      Name: "吴忠市",
      ProvinceBin: 64,
      ProvinceName: "宁夏"
    },
    {
      Bin: 640400,
      Name: "固原市",
      ProvinceBin: 64,
      ProvinceName: "宁夏"
    },
    {
      Bin: 640500,
      Name: "中卫市",
      ProvinceBin: 64,
      ProvinceName: "宁夏"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 650100,
      Name: "乌鲁木齐市",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 650200,
      Name: "克拉玛依市",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 652100,
      Name: "吐鲁番地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 652200,
      Name: "哈密地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 652300,
      Name: "昌吉回族自治州",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 652700,
      Name: "博尔塔拉蒙古自治州",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 652800,
      Name: "巴音郭楞蒙古自治州",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 652900,
      Name: "阿克苏地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 653000,
      Name: "克孜勒苏柯尔克孜自治州",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 653100,
      Name: "喀什地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 653200,
      Name: "和田地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 654000,
      Name: "伊犁哈萨克自治州",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 654200,
      Name: "塔城地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 654300,
      Name: "阿勒泰地区",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 659001,
      Name: "石河子市",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 659002,
      Name: "阿拉尔市",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 659003,
      Name: "图木舒克市",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 659004,
      Name: "五家渠市",
      ProvinceBin: 65,
      ProvinceName: "新疆"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 71,
      ProvinceName: "台湾省"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 81,
      ProvinceName: "香港"
    },
    {
      Bin: 0,
      Name: "不限",
      ProvinceBin: 82,
      ProvinceName: "澳门"
    }
  ],
  district: []
};

export default data;
